<div style="padding: 24px;">
  <h3 mat-dialog-title class="text-center">Eliminar país / Delete Country</h3>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <h6 class="text-center mt-6 mb-6">Está seguro de eliminar el país? / Are you sure to remove the country?</h6>
  </div>
  <div mat-dialog-actions>
    <button mat-button  mat-dialog-close (click)="onNoClick(false)">Cancelar / Cancel</button>
    <button mat-button cdkFocusInitial (click)="submit()">Delete / Delete</button>
  </div>
</div>
